import { Injectable } from '@angular/core';
import { InitAppAction } from '@core/state/app/app-actions';
import { IAppState } from '@core/state/app/app-state';
import { ToastService } from '@core/state/toast/toast.service';
import { Store } from '@ngrx/store';
import { IconService } from '@shared/elements/icon/icon.service';
import { PhoneUtilService } from '@shared/services/phone-util.service';

@Injectable()
export class AppService {

    constructor(private store$: Store<IAppState>,
                private toastService: ToastService,
                private phoneUtilService: PhoneUtilService,
                private iconService: IconService) {

    }

    initApp() {
        this.store$.dispatch(new InitAppAction());
        this.phoneUtilService.loadUpUtilities();
        this.iconService.fetchIcons();
    }
}